import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Image from 'gatsby-image'

import Layout from '../components/layout'
import Animated from '../components/animated'

const Section = ({ number, src, title, children }) => {
  return (
    <section className="container py-16 xl:pb-48 flex flex-wrap items-center justify-center text-lg xl:text-xl">
      <div className="w-full xl:w-1/2 flex justify-center xl:justify-end">
        <div className="w-full relative mb-12 xl:mb-0 xl:mr-32">
          <Image fluid={src} />
          <div className="absolute top-0 left-0 -mt-12 -ml-12">
            <p className="counter">{number}</p>
          </div>
        </div>
      </div>
      <div className="w-full xl:w-1/2">
        <Animated>
          <h2 className="text-4xl xl:text-5xl mb-4 xl:mb-8">{title}</h2>
        </Animated>
        <Animated>{children}</Animated>
      </div>
    </section>
  )
}

export default () => {
  const { find, search, watch, vote } = useStaticQuery(graphql`
    query {
      find: file(relativePath: { eq: "doodles/find.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      search: file(relativePath: { eq: "doodles/search.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      watch: file(relativePath: { eq: "doodles/watch.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      vote: file(relativePath: { eq: "doodles/vote.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)
  const img1 = find?.childImageSharp?.fluid
  const img2 = search?.childImageSharp?.fluid
  const img3 = watch?.childImageSharp?.fluid
  const img4 = vote?.childImageSharp?.fluid
  return (
    <Layout>
      <section className="mb-16 py-16 xl:py-48">
        <div className="container max-w-7xl flex flex-wrap items-center">
          <div className="w-full xl:w-3/5 mb-8 xl:mb-0 text-center xl:text-left">
            <h1 className="text-5xl xl:text-6xl font-thin md:pr-4">
              Discover bias in {' '}
              <span className="italic font-bold text-red-600">Youtube</span> channels
            </h1>
            <div className="flex justify-center xl:justify-start mt-8 mb-4">
              <a
                href="https://chrome.google.com/webstore/detail/youtube-bias/ofldnfalppcdaohgmimiginojinefngp"
                className="btn text-2xl"
              >
                Get Started
              </a>
            </div>
          </div>
          <div className="w-full xl:w-2/5">
            <Image fluid={img1} />
          </div>
        </div>
      </section>

      <Section number={1} title="Search for a Video" src={img2}>
        <p>
          Download the extension for the Chrome Store.
        </p>
        <br />
        <p>
          Browse Youtube for a video you want to watch.
        </p>
      </Section>

      <Section number={2} title="Watch the Video" src={img3}>
        <p>
          Watch the video and keep an eye out for bias the video may show.
        </p>
      </Section>

      <Section number={3} title="Vote" src={img4}>
        <p>
          Use the extension to vote if the video contained a significant bias and 
          view how other users voted.
        </p>
      </Section>

      <section className="border-t bg-gray-100 py-16 xl:py-32" id="faq">
        <div className="container">
          <h3 className="text-center text-3xl mb-8">FAQ</h3>
          <div className="grid sm:grid-cols-2 xl:grid-cols-2 gap-4">
            <div className="card">
              <p className="font-bold mb-2">
                Why should I care about bias on Youtube?
              </p>
              <p>
                Bias exists all around us and is constantly working to influence
                our thoughts and decisions. Being aware of bias in the content 
                you consume will allow you to form well-rounded opinions.
              </p>
            </div>
            <div className="card">
              <p className="font-bold mb-2">
                How can I spot bias in videos?
              </p>
              <p>
                Think about the creator(s) of the video. What might be their motive?
                Are they trying to sell you something? Might they be funded by a
                group that would benefit from the narrative they are pushing?
              </p>
            </div>
            <div className="card">
              <p className="font-bold mb-2">
                How do I install the extension?
              </p>
              <p>
                Installation is simple! Click on the download link, and click the
                blue &apos;add to chrome&apos; button. The extension is now installed. To open it,
                click the puzzle icon in the top right of your browser and select
                Youtube Bias.
              </p>
            </div>
            <div className="card">
              <p className="font-bold mb-2">
                How do I vote?
              </p>
              <p>
                It&apos;s easy! Open the youtube video you want to vote on, and open the 
                extension. Select the &apos;biased&apos; or &apos;not biased&apos; button depending on
                how you want to vote.
              </p>
            </div>
            {/* <div className="card">
              <p className="font-bold mb-2">What do we do with Google data?</p>
              <p>
                We let users connect with their Google account for a more
                seamless experience. If granted access, we store your Google
                OAuth token in a secure database. If requested, we will delete
                our OAuth token to restrict our access. We only request access
                to the scopes required to perform the necessary actions.
              </p>
            </div> */}
            {/* <div className="card">
              <p className="font-bold mb-2">
                How does connecting with Google enhance user functionality?
              </p>
              <p>
                By integrating with your Google account, we can automate various
                processes including: (1) incoming email forwarding, (2) filter
                creation, and (3) email labeling. We only look at incoming
                emails and do not share your emails with any third-party. A user
                is not required to connect with Gmail and can later disconnect
                their account from Gmail if they wish.
              </p>
            </div> */}
          </div>
        </div>
      </section>
    </Layout>
  )
}
